import React, { useEffect } from "react";
import InputDate from "../../../common/Input/InputDate";
import InputTime from "../../../common/Input/InputTime";
import { getAllLabReport } from "../../../../store/slices/labReportSlice";
import { useDispatch, useSelector } from "react-redux";

const CollectionReceived = ({ handleChange, labReportFormData }) => {
  const dispatch = useDispatch();
  const { clinicInfo } = useSelector((state) => state.clinic);
  const { token } = useSelector((state) => state.auth);
  const labReportId = sessionStorage.getItem("labReportId");

  const clinicId = clinicInfo?.[0]?.clinicId || null;
  useEffect(() => {
    dispatch(
      getAllLabReport({
        clinicId,
        id: labReportId,
        token,
      }),
    );
  }, [dispatch, clinicId, labReportId, token]);

  return (
    <div className="card">
      <div className="card-body">
        <h4 className="mb-4">Collection and Received Date / Time</h4>
        <div className="row">
          <div className="col-xl-3">
            <InputDate
              name="collectionDate"
              value={labReportFormData?.collectionDate}
              onChange={handleChange}
              placeholder="Collection Date"
              validateFutureDate={false}
              required={true}
            />
          </div>
          <div className="col-xl-3">
            <InputTime
              name="collectionTime"
              value={labReportFormData?.collectionTime}
              onChange={handleChange}
              placeholder="Collection Time"
              required={true}
            />
          </div>
          <div className="col-xl-3">
            <InputDate
              name="receivedDate"
              value={labReportFormData?.receivedDate}
              onChange={handleChange}
              placeholder="Received Date"
              validateFutureDate={false}
              required={true}
            />
          </div>
          <div className="col-xl-3">
            <InputTime
              name="receivedTime"
              value={labReportFormData?.receivedTime}
              onChange={handleChange}
              placeholder="Received Time"
              required={true}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CollectionReceived;
